import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { PreviousDecision, SellerMessages } from 'components/project/AuctioneerScreen';
import styled from 'styled-components';

const buttonHeight = '80px';
const fontSize = '2em';

const Container = styled.div`
  grid-area: controls;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #eee;
  border: 1px solid gray;
  padding: 0px 5px;
  text-transform: uppercase;
  & .buttonsContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 0px;
    padding-bottom: 10px;
    width: 100%;
    text-align: center;
    & button {
      width: 100px;
      font-weight: bold;
      height: ${buttonHeight};
      font-size: ${fontSize};
      justify-content: center;
      margin: 10px;
      & i {
        font-size: ${fontSize};
      }
    }
  }
`;


const ControlsContainer = () => {
  const {
    AuctionStore: { laneStatus },
    BidStore: { laneSuspended },
  } = useStores();

  return (
    <>
      <Container suspended={laneSuspended} ended={laneStatus === 'Ended'}>
        {/* <div className="buttonsContainer">
          <PauseContinueLane
            show={laneStatus !== 'Ended'}
            onClick={handlePauseLane}
            bgColor="#FBCC08"
            color="#000000"
            bgVariance={20}
            icon={lanePaused ? 'fa-play-circle' : 'fa-pause-circle'}
            isLanePaused={lanePaused}
            iconOnly
          />
          <MuteLaneMedia iconOnly />
        </div> */}
      </Container>
      <SellerMessages />
      {/* <AuctioneerName />
      <LaneStats /> */}
      <PreviousDecision />
    </>
  );
};

export default observer(ControlsContainer);
